module.exports = __webpack_public_path__ + "img/131.4c3d882c.gif";